import * as React from "react";
import Button from "../../../../../Button/Button";
import "./MobileBookPeekCategory.css";
import Dialog from "@material-ui/core/Dialog/Dialog";
import PeekCategory from "../../../../../PeekCategory/PeekCategory";
import { getCollections } from "../../../../../../store/collections/selectors";
import { useSelector } from "react-redux";
import { Book } from "../../../../../../types/Book";
import IconButton from "@material-ui/core/IconButton/IconButton";
import CloseIcon from "@material-ui/icons/Close";

const cationIcon = (
	<svg
		width="40"
		height="40"
		viewBox="0 0 40 40"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<circle cx="20" cy="20" r="18.5" stroke="white" stroke-width="3" />
		<path
			d="M21.2109 22.5977H18.0117L17.5078 10.9375H21.7148L21.2109 22.5977ZM17.3906 26.2305C17.3906 25.6523 17.5977 25.1797 18.0117 24.8125C18.4336 24.4375 18.957 24.25 19.582 24.25C20.207 24.25 20.7266 24.4375 21.1406 24.8125C21.5625 25.1797 21.7734 25.6523 21.7734 26.2305C21.7734 26.8086 21.5625 27.2852 21.1406 27.6602C20.7266 28.0273 20.207 28.2109 19.582 28.2109C18.957 28.2109 18.4336 28.0273 18.0117 27.6602C17.5977 27.2852 17.3906 26.8086 17.3906 26.2305Z"
			fill="white"
		/>
	</svg>
);

interface Props {
	book: Book;
}

const MobileBookPeekCategory: React.FC<Props> = (props) => {
	const [open, setOpen] = React.useState(false);
	const categories = useSelector(getCollections);

	return (
		<div className="cation-category">
			{cationIcon}

			<div className="cation-category-text">
				<div>У этой книги не указана категория</div>
				<Button onClick={() => setOpen(true)}>Исправить</Button>
			</div>

			<Dialog fullScreen={true} open={open} onClose={() => setOpen(false)}>
				<div className="cation-category-popup">
					<div className="cation-category-header">Выберите категорию</div>

					<IconButton
						className="cation-category-close"
						onClick={() => setOpen(false)}
					>
						<CloseIcon />
					</IconButton>

					<PeekCategory book={props.book} categories={categories} />
				</div>
			</Dialog>
		</div>
	);
};

export default MobileBookPeekCategory;
